module.exports = __webpack_public_path__ + "e5c12fcb37d52eb05e48eca3c94eeccc.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/covers/cover_20.jpg
 ** module id = 603
 ** module chunks = 0
 **/